import * as React from "react";
const SvgDotSmall = props => <svg xmlns="http://www.w3.org/2000/svg" width={256} height={256} fill="currentColor" viewBox="0 0 16 16" {...props}><path d="M8 3a5 5 0 1 0 0 10A5 5 0 0 0 8 3" /></svg>;
export default SvgDotSmall;